// extracted by mini-css-extract-plugin
export var colorSquare = "_nj-0";
export var container = "_nj-h";
export var danger = "_nj-5";
export var lightPink = "_nj-8";
export var neutralBlue = "_nj-7";
export var neutralYellow = "_nj-6";
export var normal = "_nj-1";
export var primary = "_nj-2";
export var primaryLight = "_nj-3";
export var selected = "_nj-i";
export var solidBlack = "_nj-g";
export var solidGreen = "_nj-b";
export var solidLightBlue = "_nj-d";
export var solidNavy = "_nj-c";
export var solidOrange = "_nj-f";
export var solidPink = "_nj-e";
export var solidRed = "_nj-9";
export var solidYellow = "_nj-a";
export var success = "_nj-4";